<template>
  <LoaderComponent v-if="loadingData"></LoaderComponent>
  <div v-if="foodInfoData" style="margin-left: 20px;margin-right: 20px;">
    <div class="bold titolo backgroudlistwhite" style="padding-top: 10px;padding-bottom: 10px;padding-left:5px; margin-top: 10px;margin-bottom: 10px; border: 4px solid #49c0de;">{{ foodInfoData.idFoodShort }} {{
      foodInfoData.description }}
      <div style="margin-top: -5px; float: right; padding-right: 5px;" class="testobianco"><img width="82" height="30"
          v-if="foodInfoData.version == 1" src="../assets//mela-rossa.png" /></div>
      <div style="margin-top: -5px;float: right;  padding-right: 5px" class="testobianco"><img width="82" height="30"
          v-if="foodInfoData.version == 2" src="../assets//mela-verde.png" /></div>
      <div style="margin-top: -5px;float: right;  padding-right: 5px" class="testobianco"><img width="82" height="30"
          v-if="foodInfoData.version == 3" src="../assets//mela-blu.png" /></div>
      <div style="margin-top: -5px;float: right;  padding-right: 5px" class="testobianco"><img width="82" height="30"
          v-if="foodInfoData.version == 4" src="../assets//mela-viola.png" /></div>
    </div>

    <div class="bold testonormale" style="margin-top: 5px;">{{ S0010 }} <span class="regular">{{ foodInfoData.note
    }}</span>
    </div>
    <div class="bold testonormale" style="margin-top: 5px;">{{ S0011 }} <span class="regular">{{
      foodInfoData.catMercIdentifier }} - {{ foodInfoData.catMercDescription }}</span></div>
  </div>
</template>

<script>
import api from "../js/apiConsts.js";
import apiConsts from "../js/apiConsts.js";
import { axiosPost } from "../js/apiService.js";
import LoaderComponent from "./LoaderComponent.vue";
import { getSTRING } from "@/js/utils";
export default {
  name: "FoodInfo",
  components: {
    LoaderComponent,
  },
  emits: { error: null },
  props: ["id", "lang"],
  data() {
    return {
      language: this.lang.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1,
      foodInfoData: null,
      loadingData: false,
      TITOLO: '',
      S0010: '',
      S0011: ''
    };
  },
  async mounted() {
    await this.loadFoodInfo();
    this.TITOLO = getSTRING(this.lang, "TITOLO", apiConsts.TITOLOAPP);
    this.S0010 = getSTRING(this.lang, "S0010", "Note Alimento:");
    this.S0011 = getSTRING(this.lang, "S0011", "Categoria merceologica:");
  },
  methods: {
    async loadFoodInfo() {
      this.loadingData = true;
      await axiosPost(api.APIFoodInfo, {
        language: this.language,
        foodId: this.id,
      })
        .then((response) => {
          let res = response.data;
          this.foodInfoData = null;
          this.loadingData = false;
          if (res.success) {
            this.foodInfoData = res.foodInfo;
          } else {
            this.$emit('error', res.message);
          }
        })
        .catch((err) => {
          this.loadingData = false;
          this.$emit('error', err.message);
        });
    },
  },
};
</script>

<style scoped></style>